import { App } from "~/pages/integrations/IntegrationsSetup/IntegrationSetupPage";
import { Config } from "~/constants/configuration_provider";
import { useToken } from "~/providers/token";
import { TokenTimerWidget } from "~/components/token-timer";
import { useCanCreate } from "~/lib/iam/actions/mondoo/integrations/IntegrationsManager/Create";
import { useCanCreateAgent } from "~/lib/iam/actions/mondoo/agents/AgentManager/CreateAgent";
import { K8ConfigurationPanel } from "~/pages/integrations/kubernetes/K8ConfigurationPanel";
import { Paper, Typography } from "@mui/material";
import { Markdown } from "~/components/markdown";
import { Component } from "react";
import { styled } from "@mui/material/styles";
import { IntegrationSetupDetailCredentialsDownloader } from "~/pages/integrations/IntegrationsSetup/IntegrationSetupDetail/IntegrationSetupDetailCredentialsDownloader";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";

interface IntegrationSetupDetailAddDefualtConfigProps {
  scope: SpaceScope | OrganizationScope;
  item: App;
}

export const IntegrationSetupDetailAddDefaultConfig = ({
  scope,
  item,
}: IntegrationSetupDetailAddDefualtConfigProps) => {
  const { token } = useToken();
  const hasCreateK8IntegrationPermission = useCanCreate();
  const hasCreateAgentPermission = useCanCreateAgent();
  let sections = [];

  // @TODO refactor this to use keys prop more efficiently
  // include token ticker
  if ("credentials" in item && "token" in item.credentials) {
    if (!hasCreateAgentPermission) {
      sections.push(<NoPermissionConfiguration key={sections.length} />);
    } else {
      sections.push(<TokenTimerWidget key={sections.length} />);
    }
  }

  if ("credentials" in item && "download" in item.credentials) {
    if (!hasCreateAgentPermission) {
      sections.push(<NoPermissionConfiguration key={sections.length} />);
    } else {
      sections.push(
        <IntegrationSetupDetailCredentialsDownloader
          scope={scope}
          key={sections.length}
        />,
      );
    }
  }

  if ("customization" in item) {
    if (item.title === "Kubernetes") {
      sections.push(
        <K8ConfigurationPanel
          data={item.customization}
          scope={scope}
          key={sections.length}
          hasCreateK8IntegrationPermission={hasCreateK8IntegrationPermission}
        />,
      );
    }
  }

  // render all docs sections
  if ("documentation" in item) {
    Object.entries(item.documentation).forEach(([key, entry]) => {
      const tokenValue = token == null ? "PASTE_TOKEN" : token.value;
      const title = "title" in entry ? entry.title : "";
      const description = entry.description
        .replace(/\%TOKEN\%/g, tokenValue)
        .replace(/\%INSTALL_HOST\%/g, Config.VITE_INSTALL_HOST)
        .replace(/\%RELEASES_HOST\%/g, Config.VITE_RELEASES_HOST);
      sections.push(
        <BashExample
          key={key + description}
          title={title}
          name={title}
          description={description}
        />,
      );
    });
  }

  return <ContentPaper>{sections}</ContentPaper>;
};

const ContentPaper = styled(Paper)`
  padding: 16px;
`;

type BashExampleProps = {
  title: string;
  description: string;
  name: string;
};

function BashExample({ title, description, name }: BashExampleProps) {
  return (
    <div key={`${name}-${title}-bash-example`}>
      {title != null && <Typography variant="h4">{title}</Typography>}
      <Markdown source={description} />
    </div>
  );
}

class NoPermissionConfiguration extends Component {
  state = {};

  render() {
    return (
      <ContentPaper>
        <Typography variant="h4">Configuration</Typography>
        <p>You have no permission to generate credentials</p>
      </ContentPaper>
    );
  }
}
